import React, { memo } from 'react';
import moment from 'moment-jalaali';

import { convertDigitToProperFormat } from 'utils/number';
import { IPrintPartProps } from 'store/entity/IPrintTemplatePart';
import {
  PrintSingleTaskConsumer,
  IPrintSingleTaskContext,
} from 'store/context/PrintSingleTaskContext';

import messages from './Messages';
import { SingleTaskPart } from '../styles';

type validFormats = 'date' | 'hours' | 'datetime';

const getDateFormat: { [key in validFormats]: string } = {
  date: 'jYYYY/jMM/jD',
  hours: 'HH:mm',
  datetime: 'jYYYY/jMM/jD HH:mm',
};

const DatePart: React.FC<IPrintPartProps<'dueDate' | 'startDate'>> = ({
  item,
  taskId,
  property,
}) => (
  <PrintSingleTaskConsumer>
    {(dataContext: IPrintSingleTaskContext) => {
      const { allTasks, company } = dataContext;
      const {
        part,
        options: { view, format, customTitle },
      } = item;

      const showBothKeyValue = view === 'both';
      let showKey = showBothKeyValue;
      let showValue = showBothKeyValue;

      if (!showBothKeyValue) {
        showKey = view === 'key';
        showValue = view === 'value';
      }

      let keyTitle;
      let valueTitle;

      if (showKey) {
        const templateId = allTasks?.find(
          (task) => task.id === taskId
        )?.templateId;
        const companyTemplate = company?.templates?.find(
          (template) => template.taskId === templateId
        );
        const whichTitle = `${part}Title` as 'dueDateTitle' | 'startDateTitle';
        keyTitle = messages.getDateTitle(
          part,
          showBothKeyValue,
          customTitle ? customTitle : companyTemplate?.task?.[whichTitle]
        );
      }
      if (showValue) {
        valueTitle = property
          ? convertDigitToProperFormat(
              moment(property).format(getDateFormat[format])
            )
          : messages.fieldIsEmpty;
      }
      return (
        <SingleTaskPart>
          <span>{showKey && keyTitle}</span>
          <span>{showValue && valueTitle}</span>
        </SingleTaskPart>
      );
    }}
  </PrintSingleTaskConsumer>
);

export default memo(DatePart);
